import { OBaseModel } from '@olameter/o-utilities';
import { UserResult } from 'src/app/proto/generated/User_message_pb';
import { UserFileModel } from './user-file.model';
import { UserGroupModel } from './user-group.model';

export class UserModel implements OBaseModel {
  name: string;
  groupsList: UserGroupModel[];
  userName: string;
  email: string;
  status: boolean;
  userFile: UserFileModel;

  static Mapper(userResponse: UserResult): UserModel {
    const g = userResponse.getUserGroupsList();
    const groupL: UserGroupModel[] = [];

    g?.forEach((element) => {
      groupL.push({
        name: element.getName() as string,
        userGroupName: element.getUserGroupName(),
      });
    });
    return {
      name: userResponse.getName(),
      groupsList: groupL,
      userName: userResponse.getUserName(),
      email: userResponse.getEmail(),
      status: userResponse.getStatus(),
      userFile: UserFileModel.Mapper(userResponse.getUserFile()),
    };
  }
}
